import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { DeclineDocumentWithSignerTokenRequest, DeclineDocumentWithSignerTokenResponse } from "@maven-rest/docs/DocumentSign.dto";
import { DocumentSignerUrl } from "@maven-rest/docs/DocumentSigner.url";

export function useDeclineDocumentWithSignerTokenMutation(req: {
  onSuccess: (data: DeclineDocumentWithSignerTokenResponse, variables: DeclineDocumentWithSignerTokenRequest, context: unknown) => void;
  onError: (
    error: RestError<DeclineDocumentWithSignerTokenResponse>,
    variables: DeclineDocumentWithSignerTokenRequest,
    context: unknown
  ) => void;
}) {
  return useBaseMutation({
    fnOption: {
      url: DocumentSignerUrl.declineDocumentWithSignerToken,
    },
    onSuccess: req.onSuccess,
    onError: req.onError,
  });
}
